<div class="p-grid">
    <div class="p-col-12">
        <p-menu #configmenu id="config_menu" [model]="configMenuItems" (onShow)="getItemMenu()" [popup]="true"></p-menu>
        <div class="tab-wrapper">
            <div class="tab-rightmenu-wrapper">
                <div *ngIf="!hideAddEdit">
                    <div class="btnBars" pTooltip="Minimize" tooltipPosition="top" (click)="menuShow('table')" *ngIf="isLeftTableHide">
                        <i class="pi pi-minus-circle"></i>
                    </div>
                    <div class="btnBars" pTooltip="Maximize" tooltipPosition="top" (click)="menuHide('table')" *ngIf="!isLeftTableHide">
                        <i class="pi pi-plus-circle"></i>
                    </div>
                    <div class="btnBars" pTooltip="Show Menu Bar" tooltipPosition="top" (click)="menuShow('menu');" *ngIf="!isMenuShow">
                        <i class="pi pi-arrow-down"></i>
                    </div>
                    <div class="btnBars" pTooltip="Hide Menu Bar" tooltipPosition="top" (click)="menuHide('menu');" *ngIf="isMenuShow">
                        <i class="pi pi-arrow-up"></i>
                    </div>
                    <div class="btnBars">
                        <i class="pi pi-bars" (click)="configmenu.toggle($event)"></i>
                    </div>
                    <div class="btnBars" (click)="closeSplitViewChild()">
                        <i class="pi pi-times"></i>
                    </div>
                </div>
            </div>
            <p-tabView (onChange)="changeTab($event)" [(activeIndex)]="selectedTabIndex" class="custom-tablist custom-tablist-button tab-rightmenu" [scrollable]="true">
                <p-tabPanel header="Overview">
                    <div *ngIf="selectedTabIndex == accountViewTabIndex.OVERVIEW">
                        <div class="p-m-2">
                            <app-account-lead-detail-block *ngIf="filteredAccount" [moduleId]="accountModuleId" [mergeAccountSequenceNumber]="mergeAccountSequenceNumber"
                                [column]="savedDetailViewCols" [data]="filteredAccount" (reloadDetails)="reloadDetails.emit($event)">
                            </app-account-lead-detail-block>
                        </div>

                        <p-overlayPanel #accountName [showCloseIcon]="true" [style]="{width: '550px'}">
                            <ng-template pTemplate>
                                <p-table [value]="accountNameData" [paginator]="true" [rows]="5">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th id="name">Name</th>
                                            <th id="phone">Phone</th>
                                            <th id="designation">Designation</th>
                                            <th id="email">Email</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData>
                                        <tr>
                                            <td>{{rowData.name}}</td>
                                            <td>{{rowData.phone}}</td>
                                            <td>{{rowData.designation}}</td>
                                            <td>{{rowData.email}}</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </ng-template>
                        </p-overlayPanel>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Activity">
                    <div *ngIf="selectedTabIndex == accountViewTabIndex.ACTIVITY">
                        <app-shared-activities-timeline *ngIf="selectedAccount" [objectId]="selectedAccountFromTable"
                            objectType="Account" [isViewMode]="selectedAccount.statusId != 1" [hideEmailSyncIcon]="false"
                            [hideRigthArrow]="hideAddEdit" [selectedObject]="selectedAccount"
                            [channelId]="filteredAccount.typeId" [objectTypeId]="objectTypeId"
                            (taskAdded)="onAddTask($event)" [stagesCountN]="stagesCountN">
                        </app-shared-activities-timeline>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="List">
                    <div *ngIf="selectedTabIndex == accountViewTabIndex.List">
                        <app-account-inventory-details
                        [hasChildAccounts]="hasChildAccounts"
                        [accountId]="selectedAccount?.id"
                        [selectedAccount]="selectedAccount"
                        [checkedFields]="checkedFields"
                        [savedDetailViewCols]="savedDetailViewCols"
                        [tabList]="subTabList" [objectTypeId]="objectTypeId" 
                        [isLeftTableHide]="isLeftTableHide"
                        [activeSubtabIndex]="activeSubtabIndex"
                        (deleteSubtab)="deleteSublist($event,true)">
                        </app-account-inventory-details>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Contacts" *ngIf="readContactPermission">
                    <lion-shared-contacts *ngIf="selectedTabIndex == accountViewTabIndex.CONTACT" [contacts]="contactList"
                        (contactAdded)="getAccountContacts($event)" (contactInfo)="addContact($event)" [selectedChannel]="selectedChannel"
                        [addUpdateDone]="addUpdateDone" (contactUpdated)="editContact($event)" [isDisableAssociation]="true"
                        (contactDeleted)="contactDeleted($event)" [allAssociationNamesList]="leadsData"
                        [isViewMode]="selectedAccount?.statusId != 1" [object]="selectedAccount" [hasChildAccounts]="hasChildAccounts"
                        [contactAssociationId]="contactAssociationId" moduleName="Account" [hideRigthArrow]="hideAddEdit">
                    </lion-shared-contacts>
                </p-tabPanel>
        
                    <p-tabPanel header="Documents">
                        @if(displayDocumentList){
                        <app-documents-management [displayDocumentList]="displayDocumentList" [selectedData]="selectedAccount" [selectedModuleId]="accountModuleId" [selectedChannel]="selectedChannel"></app-documents-management>
                        }
                    </p-tabPanel>
                
                
                <p-tabPanel header="User Access">
                    <p-treeTable [value]="access" [scrollable]="true" [tableStyle]="{'min-width':'50rem'}">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Access Type</th>
                                <th>Primary Contact</th>
                                <th>Other Contact</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                            <tr [ttRow]="rowNode">
                                <td>
                                    <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                                    {{rowData.accessType}}
                                </td>
                                <td>{{rowData.userName}}</td>
                                <td>{{rowData.otherContact}}</td>
                            </tr>
                        </ng-template>
                    </p-treeTable>
                </p-tabPanel>
                <p-tabPanel header="Opportunities" *ngIf="opportunityReadPemission">
                    <app-account-detail-table *ngIf="selectedTabIndex == accountViewTabIndex.OPPORTUNITY" [module]="'Opportunity'" [filteredAccount]="selectedAccount" [selectedAccountChannel]="selectedChannel"></app-account-detail-table>
                </p-tabPanel>
                <p-tabPanel header="Cases" *ngIf="casesReadPermission">
                    <app-account-detail-table *ngIf="selectedTabIndex == accountViewTabIndex.CASES" [module]="'Case'" [filteredAccount]="selectedAccount" [selectedAccountChannel]="selectedChannel"></app-account-detail-table>
                </p-tabPanel>
                <p-tabPanel header="Transactions" *ngIf="transactionPermission" >
                    <div class="p-grid">
                        <div class="p-col p-p-0" style="position: relative;">
                            <!-- <span class="btnBars" style="position: absolute;right: 0;"
                            pTooltip="Column Setting" tooltipPosition="left" (click)="financeSetting()"
                            *ngIf="column2.length == 0">
                                <i class="pi pi-cog"></i>
                            </span> -->
                            <ng-container *ngFor="let col of column1">
                                <div class="p-mb-1 p-d-flex border-bottom p-p-2 detail-row">
                                    <div style="width: 25%;word-break: break-word;" pTooltip="{{ col.name }}">
                                        <strong>{{col.name}}</strong>
                                    </div>
                                    <span style="width: 75%;">
                                        <span pTooltip="{{financeData ? financeData[col?.columnName] : 0}}" style="white-space: pre-line;word-break: break-all;"
                                        tooltipPosition="top">
                                            {{(financeData ? financeData[col?.columnName] : 0) | customNumberFormat: decimalPlaces | currencySymbol}}
                                        </span>
                                        <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top" *ngIf="col.name == 'Opening Balance'" >
                                            <i *ngIf="!financeData?.asOfDate ? true : false" class="pi pi-pencil" (click)="OpeningBalance()"></i>
                                        </span>
                                        <span *ngIf="col.name === 'Opening Balance' && financeData?.asOfDate">
                                            as of Date {{ openingBalanceDate ? (openingBalanceDate | date: 'MM/dd/yyyy') : "" }}
                                        </span>
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                        <p-divider *ngIf="column2.length" layout="vertical"></p-divider>
                        <div class="p-col p-p-0" *ngIf="column2.length" style="position: relative;">
                            <span class="btnBars" style="position: absolute;right: 0;"
                            pTooltip="Column Setting" tooltipPosition="left" (click)="financeSetting()">
                                <i class="pi pi-cog"></i>
                            </span>
                            <ng-container *ngFor="let col of column2">
                                <div class="p-mb-1 p-d-flex border-bottom p-p-2 detail-row">
                                    <div style="width: 25%;word-break: break-word;" pTooltip="{{ col.name }}">
                                        <strong>{{col.name}}</strong>
                                    </div>
                                    <span style="width: 75%;">
                                        <span pTooltip="{{financeData ? financeData[col?.columnName] : 0}}" style="white-space: pre-line;word-break: break-all;"
                                        tooltipPosition="top">
                                            {{(financeData ? financeData[col?.columnName] : 0) | number: "1.2-2" | currencySymbol}}
                                        </span>
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="detail-row p-mt-3">
                        <p-tabView #transactionTab [(activeIndex)]="activeIndex" (onChange)="onTabChange($event)">
                            <p-tabPanel header="List by Type">
                                <p-table [value]="financeData?.txnList" responsiveLayout="scroll"
                                styleClass="p-datatable-gridlines" [resizableColumns]="true"
                                (onRowSelect)="onRowSelectTrans()"
                                
                                dataKey="referenceId" [rows]="pageSize" (onRowSelect)="onRouteNavigation($event)"
                                (onRowUnselect)="selectedTransRow = null;" [(contextMenuSelection)]="selectedTransRow"
                                selectionMode="single" [(selection)]="selectedTransRow">
                                    <ng-template pTemplate="caption">
                                        <div class="p-d-flex">
                                            <h5 style="display: inline;" class="p-mb-0 p-mt-1">Filter By - </h5>
                                            <p-dropdown [options]="filteredTransactionTypes" id="purchaseChannels"
                                                [(ngModel)]="selectedTransaction" optionLabel="name"
                                                appendTo="body" class="channelClass" placeholder="Select type"
                                                (onChange)="getFinanceData()">
                                            </p-dropdown>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th pResizableColumn>Type</th>
                                            <th pResizableColumn>Ref. No.</th>
                                            <th pResizableColumn>Date</th>
                                            <th pResizableColumn>Chart of Account</th>
                                            <th pResizableColumn>Amount</th>
                                            <th pResizableColumn>Balance Due</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-transaction let-i="rowIndex">
                                        <tr [pSelectableRow]="transaction" [pContextMenuRow]="transaction">
                                            <td>{{transaction.transactionType}}</td>
                                            <td>{{transaction.referenceNo}}</td>
                                            <td>{{transaction.processedDate  | date: 'MM/dd/yyyy'}} </td>
                                            <td>{{transaction.chartOfAccount}}</td>
                                            <td>{{transaction.amount | customNumberFormat: decimalPlaces | currencySymbol}}
                                            </td>
                                            <td><span *ngIf="transaction.transactionType=='Invoice'">{{transaction.balanceDue | customNumberFormat: decimalPlaces | currencySymbol}}</span></td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </p-tabPanel>
                            <p-tabPanel header="Sales History">
                                <app-sales-history [salesHistory]="salesHistory" [decimalPlaces]="decimalPlaces"
                                [searchValueSales]="searchValueSales" [totalRecordSales]="totalRecordSales" [qtyDecimal]="qtyDecimal"
                                (getSalesHistory)="getSalesHistory($event)" [module]="'account'" (openLocationDialog)="openLocationDialog($event)"
                                [noSalesFindOrLoadingText]="noSalesFindOrLoadingText"></app-sales-history>
                            </p-tabPanel>
                        </p-tabView>
                    </div>
                </p-tabPanel>

                <!---- Dynamic Tab List -------->

                <ng-container *ngFor="let subtabDetails of tabList; let i = index">
                    <p-tabPanel>
                        <ng-template pTemplate="header">
                            <div (click)="selectSubTab(i)" class="p-d-flex p-ai-center custom-tab-name">
                                <span style="white-space: nowrap;">{{ subtabDetails?.widgetName }}</span>
                                <!-- <span class="pi pi-times widget-delete-icon" (click)="deleteSublist(subtabDetails)"></span> -->
                            </div>
                        </ng-template>

                        <ng-container [ngSwitch]="subtabDetails?.referenceTypeName">
                            <ng-container *ngSwitchCase="'SavedSearch'">
                                <app-saved-search-table-view *ngIf="activeTabIndex==i"
                                    [tabWidgetDetails]="subtabDetails"
                                    [savedSearchId]="subtabDetails.referenceId"
                                    [showFlatTable]="true"
                                    [isLeftTableHide]="isLeftTableHide"
                                    [hideTableHeader]="true">
                                </app-saved-search-table-view>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Workbook'">
                                <app-shared-workbook-listing *ngIf="activeTabIndex==i"
                                    [tabWidgetDetails]="subtabDetails"
                                    [workbookIntId]="subtabDetails.referenceId"
                                    [isLeftTableHide]="isLeftTableHide"
                                    >
                                </app-shared-workbook-listing>
                            </ng-container>
                        </ng-container>
                    </p-tabPanel>
                </ng-container>

                <!---- Dynamic Tab List End --->
            </p-tabView>
        </div>
    </div>
</div>

<p-dialog [header]="saveBtn == 'edit' ? 'Edit Document' : 'Add New Document'" [(visible)]="displayNewUpload" [modal]="true" [closable]="false"
    [style]="{width: '60vw'}">
    <div class="card">
        <div *ngIf="saveBtn == 'edit'" class="p-grid">
            <div class="p-col-12">
                <label>Document Name</label>
                <input *ngIf="saveBtn == 'edit'" type="text" pInputText [(ngModel)]="tempDuc.name">
            </div>
        </div>
        <div *ngIf="saveBtn == 'upload'" class="p-grid">
            <div class="p-col-12 message-outer">
                <label>Upload</label>
                <p-messages [(value)]="maxFilesizeErrorMessage" [enableService]="false" [closable]="false"></p-messages>
                <p-messages [(value)]="maxNoOfFilesErrorMessage" [enableService]="false" [closable]="false"></p-messages>
                <p-messages [(value)]="specialCharacterErrorMsg" [enableService]="false" [closable]="false"></p-messages>
                <p-fileUpload multiple="multiple" maxFileSize="25000000" [files]="files" [showUploadButton]="false" (onSelect)="uploadAttachments($event.files)" (onClear)="removeAllFiles()" name="myfile[]"  #fileUploader>
                    <ng-template pTemplate="file" let-file>
                        <div class="file-info">
                            <div>
                                <img class="file-icon" [src]="getFileIcon(file.name)" alt="Invalid File">
                            </div>
                            <div [pTooltip]="file.name" class="truncate">
                                {{ file.name }}
                            </div>
                            <div>
                                {{ file.size | fileSize }}
                            </div>
                            <div>
                                <p-button icon="pi pi-times" iconPos="left" class="p-button-danger" (click)="removeFromUpload(file, fileUploader)"></p-button>
                            </div>
                        </div>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayNewUpload=false;newFileList=[];" label="Cancel"
            class="p-button-secondary"></button>
        <button *ngIf="saveBtn == 'edit'" type="submit" pButton label="Save" (click)="editDocument()"></button>
        <button  *ngIf="saveBtn == 'upload'" type="submit" [disabled]="fileList?.length == 0 || fileList?.length > 3 || totalFileSize > 25000000" pButton label="Save" (click)="save()"></button>
    </p-footer>
</p-dialog>


<!-- finance -->
<p-dialog header="Column Selection" [(visible)]="displayFinanceSetting" [modal]="true" [closable]="false"
    [style]="{width: '30vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <span class="p-input-icon-left w-100">
                    <i class="pi pi-search"></i>
                    <input type="text" pInputText placeholder="Search for field" />
                </span>
                <div cdkDropList (cdkDropListDropped)="dropCol($event)">
                    <ng-container
                        *ngFor="let col of financeCols | gblFilter: detailListSearchInput: 'name' ; let i = index">
                        <div class="colList" cdkDrag
                            [cdkDragDisabled]="!col.dragable"
                            appendTo="body" *ngIf="col.name">
                            <div class="p-d-flex">
                                <i class="fa fa-bars p-mt-1"
                                    *ngIf="col.dragable"
                                    style="margin-right: 10px; color:lightgray"></i>
                                <i class="fa fa-minus p-mt-1"
                                    *ngIf="!col.dragable"
                                    style="margin-right: 10px; color:lightgray"></i>
                                <p-checkbox [(ngModel)]="col.enabled"
                                    type="checkbox" binary="true" inputId="binary"
                                    [disabled]="((!col.enabled && maxCheckedFieldForDetails))"
                                    (onChange)="checkUncheckField($event.checked, col)" class="p-mr-2">
                                </p-checkbox>
                                <span class="p-mt-1">{{col.name}}</span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayFinanceSetting=false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="submit" pButton label="Save"></button>
    </p-footer>
</p-dialog>
<!-- Write check view -->
<app-write-check
    *ngIf="displayWriteCheck && overviewRefId"
    [display]="displayWriteCheck"
    [checkId]="overviewRefId"
    [checkDialogType]="'VIEW'"
    (close)="onCloseWriteCheckDialog($event)">
</app-write-check>

<!-- Expense view -->
<app-add-expense
    *ngIf="displayAddEditExpense && overviewRefId"
    [displayAddEditExpense]="displayAddEditExpense"
    [expenseId]="overviewRefId"
    [type]="'VIEW'"
    (close)="onCloseExpenseDialog($event)">
</app-add-expense>

<!-- Credit Card charge view -->
<app-add-credit-card-charge
    *ngIf="displayCreditCardViewDialog && overviewRefId"
    [displayAddEditCreditCard]="displayCreditCardViewDialog"
    [creditCardId]="overviewRefId"
    [type]="'VIEW'"
    (close)="onCloseCreditChargeDialog($event)">
</app-add-credit-card-charge>

<!-- bank register view-->
<app-user-register
    *ngIf="displayBankRegisterViewDialog && overviewRefId"
    [display]="displayBankRegisterViewDialog"
    [dialogType]="'VIEW'"
    [bankRegisterId]="overviewRefId"
    [accountsTransactionMasterID]="transactionMasterId"
    (close)="onCloseBankRegisterViewDialog($event)">
</app-user-register>

<app-inventory-module-overview-dialogs
    *ngIf="displayInventoryOverview"
    [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId"
    [overviewRefNumber]="inventoryOverviewRefNumber" [isShowVoidDelete]="true"
    [overviewModule]="inventoryOverviewModule" [selectedInvTransRow]="selectedTransRow"
    (onCancel)="closeViewPopup()"
    (onEdit)="openEditPopup()">
</app-inventory-module-overview-dialogs>

<app-update-opening-balance [isFlag]="accountOpeningBalance" [decimalPlaces]="decimalPlaces"
   [selectedId]="selectedAccount.id"
   (passAccountOpeningBalance)="UpdateOpeningBalance($event)">
</app-update-opening-balance>

<app-receive-payments *ngIf="displayInvoiceReceive" [receivedPaymentId]="selectedTransRow?.referenceId" [displayInvoiceReceive]="displayInvoiceReceive"
  [channelName]="selectedData"  [selectedInvoicing]="selectedInvoicing"
  [type]="receivePaymentDialogType"
  (invoiceReceiveEventEmitter)="onReceivePaymentsDialogClose($event)">
</app-receive-payments>
<app-location-view-edit *ngIf="displaylocationView" [displaylocationView]="displaylocationView"
[location]="location"  (closeLocationView)="closeLocationView($event)">
</app-location-view-edit>
<p-confirmDialog key="account-transaction-dialogs" [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
